export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const GET_KIT_LIST = 'GET_KIT_LIST'
export const GET_ACTIVE_SHEETS = 'GET_ACTIVE_SHEETS'
export const GET_WORKSPACES = 'GET_WORKSPACES'
export const GET_EXECUTION_PERIODS = 'GET_EXECUTION_PERIODS'
